import { wrapper } from "@/utils/wrapper";
import ApiService from "@/services/ApiService";

const apiService = new ApiService();

export async function calculateTreamentProgress(patientsId: number, treatmentsId: number) {
  const treatmentModules = await wrapper(apiService.getModules(patientsId, treatmentsId));
  if (treatmentModules.error) {
    throw treatmentModules.error;
  }
  
  if (treatmentModules.data) {
    const progress = treatmentModules.data.reduce((acc: number, mod: any) => acc + mod.modulesStates[0].progress, 0) / treatmentModules.data.length;
    return Math.round(progress);
  }
}
